import { render, staticRenderFns } from "./ProductGroups.vue?vue&type=template&id=fb7b413a&scoped=true"
import script from "./ProductGroups.vue?vue&type=script&lang=ts"
export * from "./ProductGroups.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroups.vue?vue&type=style&index=0&id=fb7b413a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7b413a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb7b413a')) {
      api.createRecord('fb7b413a', component.options)
    } else {
      api.reload('fb7b413a', component.options)
    }
    module.hot.accept("./ProductGroups.vue?vue&type=template&id=fb7b413a&scoped=true", function () {
      api.rerender('fb7b413a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/ProductGroups.vue"
export default component.exports